import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { getActivityFeedSettingsStore } from '../store/notificationSettingStore';
import {
    emailMentionSetting,
    likeSetting,
    documentMentionSetting,
    travelSetting,
    deliverySetting,
    onString,
    offString,
    notificationSettingTitle,
    notificationSettingDescription,
} from './ActivityFeedSettings.locstring.json';
import loc from 'owa-localize';
import { changeActivityFeedSettingValue } from '../actions/changeActivityFeedSettingValue';
import { ActivityFeedSettingIds } from '../service/ActivityFeedSettingType';
const styles = require('./ActivityFeedSettings.scss');

interface SettingsToggle {
    iconName: ControlIcons;
    label: string;
    settingType: ActivityFeedSettingIds;
    defaultValue: boolean;
}

function makeChangeCallback(settingName: ActivityFeedSettingIds) {
    return function (event: React.MouseEvent<HTMLElement>, checked?: boolean) {
        changeActivityFeedSettingValue(settingName, checked);
    };
}

export default observer(function ActivityFeedSettings() {
    const settings: SettingsToggle[] = [
        {
            iconName: ControlIcons.Accounts,
            label: emailMentionSetting,
            settingType: ActivityFeedSettingIds.emailMentionNotification,
            defaultValue: getActivityFeedSettingsStore().get(
                ActivityFeedSettingIds.emailMentionNotification
            ),
        },
        {
            iconName: ControlIcons.Like,
            label: likeSetting,
            settingType: ActivityFeedSettingIds.likeNotification,
            defaultValue: getActivityFeedSettingsStore().get(
                ActivityFeedSettingIds.likeNotification
            ),
        },
        {
            iconName: ControlIcons.Accounts,
            label: documentMentionSetting,
            settingType: ActivityFeedSettingIds.documentMentionNotification,
            defaultValue: getActivityFeedSettingsStore().get(
                ActivityFeedSettingIds.documentMentionNotification
            ),
        },
        {
            iconName: ControlIcons.Airplane,
            label: travelSetting,
            settingType: ActivityFeedSettingIds.flightNotification,
            defaultValue: getActivityFeedSettingsStore().get(
                ActivityFeedSettingIds.flightNotification
            ),
        },
        {
            iconName: ControlIcons.DeliveryTruck,
            label: deliverySetting,
            settingType: ActivityFeedSettingIds.parcelNotification,
            defaultValue: getActivityFeedSettingsStore().get(
                ActivityFeedSettingIds.parcelNotification
            ),
        },
    ];

    return (
        <div>
            <h3>{loc(notificationSettingTitle)}</h3>
            <div className={styles.descriptionText}>{loc(notificationSettingDescription)}</div>
            {settings.map(function (setting) {
                return (
                    <div key={setting.label} className={styles.settingElement}>
                        <Toggle
                            key={setting.settingType}
                            label={
                                <div className={styles.settingLabel}>
                                    <Icon
                                        className={styles.settingIcon}
                                        iconName={setting.iconName}
                                    />
                                    {loc(setting.label)}
                                </div>
                            }
                            defaultChecked={setting.defaultValue}
                            inlineLabel={true}
                            onText={loc(onString)}
                            offText={loc(offString)}
                            onChange={makeChangeCallback(setting.settingType)}
                        />
                    </div>
                );
            })}
        </div>
    );
});
